import * as core from '../../../../../../../core'
import * as girlsInc from '../girls-inc'

export const RESOURCE = {
  payload: {
    alias: 'summary',
    appAlias: girlsInc.RESOURCE.payload.alias,
    description:
      'Shows summary statistics for each Affiliate in Girls Inc. regarding a performance assessment.',
    display: {
      isMain: true,
      position: 1,
    },
    name: 'Summary',
    page: { alias: 'summary' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
